import { gql } from '@apollo/client';

export const GET_TABLE_WIDGET_ACTIVITY_APPLICATIONS = gql`
  query GetTableWidgetActivityApplications(
    $programIds: [String!]
    $activityIds: [String!]
    $range: String
    $widgetType: String
  ) {
    vm {
      activityApplications(programIds: $programIds, activityIds: $activityIds, range: $range, widgetType: $widgetType) {
        activityApplicationId
        dateApplied
        dateWithdrawn
        dateActioned
        activity {
          activityId
          name
          isActive
          priority
          program {
            name
            programId
            dateSuspended
            dateDeleted
          }
        }
        volunteer {
          volunteerId
          profile {
            profileId
            userId
            firstName
            lastName
            avatarUrl
            preferredName
          }
          dateDeactivated
          flagging {
            dateFlagged
          }
        }
      }
    }
  }
`;
